module.exports = __webpack_public_path__ + "img/워락.b732a205.png";